import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { TypographyText } from "../ReusableComponent/Reusab";
import logo from "../Assets/VBS logo-04_Org.png";
import logo1 from "../Assets/VBS Inner Page Footer.png";

import { Link, useLocation } from "react-router-dom";
const Foter = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const footerlink = [
    {
      txt: <>About Us</>,
      data: [
        {
          text1: (
            <>
              <br />
              Empowering businesses with cutting-edge digital solutions and
              compelling narratives for growth in the digital landscape.
              <br />
              <br />
            </>
          ),
        },
      ],
    },
    {
      txt: <>Important Links</>,
      data: [
        {
          text1: (
            <>
              <br /> <Link to="/">Home</Link>
            </>
          ),
        },
        { text1: <Link to={"/aboutus"}>About Us</Link> },
        { text1: <Link to={"/freequote"}>Free Quote</Link> },
        { text1: <Link to={"/faq"}>FAQ</Link> },
        {
          text1: (
            <>
              {" "}
              <Link to={"/contactus"}>Contact Us</Link>
              <br /> <br /> <br />
            </>
          ),
        },
      ],
    },
    {
      txt: <>Featured Services</>,
      data: [
        {
          text1: (
            <>
              {" "}
              <Link to={"/seo"}>SEO</Link>
            </>
          ),
        },
        { text1: <Link to={"/web-development"}>Web Development</Link> },
        { text1: <Link to={"/Presentation-design"}>Presentation Design</Link> },
        { text1: <Link to={"/seo-link-building"}>Seo Link Building</Link> },
        { text1: <Link to={"/digital-marketing"}>Digital Marketing</Link> },
        { text1: <Link to={"/graphics-design"}>Graphics Design</Link> },
        {
          text1: (
            <>
              <Link to={"/mobile-app-development"}>Mobile App Development</Link>
              <br />
            </>
          ),
        },
      ],
    },
    {
      txt: <>Contact Us</>,
      data: [
        {
          text1: (
            <>
              <ListItem sx={{ paddingLeft: 0 }}>
                <img
                  src="data:image/png;base64,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"
                  alt=""
                  width={25}
                  height={18}
                />
              </ListItem>
              <ListItem sx={{ paddingLeft: 0 }}>
                Office #9, Park Center,
                <br />
                Technopark, Trivandrum, <br />
                Kerala ,India <br />
                +91 892189 0865
              </ListItem>
              <ListItem sx={{ paddingLeft: 0 }}>
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAT4AAACfCAMAAABX0UX9AAAAPFBMVEX/AAAAAAD///8Acy8SeDfz+vbz8/MSEhKlAAClSx8AdjD/paWnTiQAezn5oqDy//v5nZ3y+PinDAwAFBSHu7fkAAABZklEQVR4nO3Qx1EEQBAAsfPeAfnnSgxXPb+VQtBmM+t6269keE+fvi/oS/Ql+hJ9ib5EX6Iv0ZfoS/Ql+hJ9ib5EX6Iv0ZfoS/Ql+hJ9ib5EX6Iv0ZfoS/Ql+hJ9ib5EX6Iv0ZfoS/Ql+hJ9ib5EX6Iv0ZfoS/Ql+hJ9ib5EX6Iv0ZfoS6b7Hs/DSqb7Xu/jSqb77rul6Ev0JfoSfYm+RF+iL9GX6Ev0JfoSfYm+RF+iL9GX6Ev0JfoSfYm+RF+iL9GX6Ev0JfoSfYm+RF+iL9GX6Ev0JfoSfYm+RF+iL9GX6Ev0JfoSfYm+RF+iL9GX6Ev0JdN9n5/TSqb7fv/OK5nuu2yXoi/Rl+hL9CX6En2JvkRfoi/Rl+hL9CX6En2JvkRfoi/Rl+hL9CX6En2JvkRfoi/Rl+hL9CX6En2JvkRfoi/Rl+hL9CX6En2JvkRfoi/Rl+hL9CX6En2JvkRfoi/Rl+hL/gFvdjwv8Db2UAAAAABJRU5ErkJggg=="
                  alt=""
                  width={25}
                  height={18}
                />
              </ListItem>
              <ListItem sx={{ paddingLeft: 0 }}>
                Office 215, B62, Riggat Al Buteen,
                <br />
                Deira, Dubai ,United Arab Emirates
                <br /> +971 58 567 2042
              </ListItem>
              <br />
            </>
          ),
        },
      ],
    },
  ];

  return (
    <div>
      <Grid
        container spacing={2}
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundSize: "100% 100%", 
          backgroundPositionX: "60%",
          backgroundImage:
            location.pathname === "/"
              ? isSmallScreen
                ? `url(https://ryse.radiantthemes.com/wp-content/uploads/2020/03/footer-bg-1.jpg)`
                : "url(https://ryse.radiantthemes.com/wp-content/uploads/2020/03/footer-bg.jpg)"
              : "none",
          backgroundColor:
            location.pathname === "/" ? "transparent" : "#332295",
          backgroundPositionY: "100%",
          pl: "8%",
          pr: "8%",
          pt: location.pathname === "/" ? "20%" : "8%",
          pb: "3%",
          textAlign: "left",
          backgroundRepeat: isSmallScreen ? "no-repeat" : "no-repeat",
           objectFit:'cover !imprtant'
        }}
      >
        {footerlink.map((post, index) => (
          <Grid
            item
            lg={index === 1 ? 2.5 : index === 3 ? 3.5 : 3}
            md={3}
            sm={6}
            xs={12}
            key={index}
            sx={{ alignSelf: "flex-start" }}
          >
            <TypographyText
              Typography={post.txt}
              fontWeight="600"
              fontSize={"1.25rem"}
              color={location.pathname === "/" ? "black" : "white"}
              textAlign="left"
            />
            <List sx={{ textAlign: "left" }}>
              {post.data.map((datas, indexs) => (
                <ListItem
                  sx={{ textAlign: "left", padding: "0 !important" }}
                  key={indexs}
                >
                  <ListItemText sx={{ textAlign: "left", padding: "0" }}>
                    <TypographyText
                      Typography={datas.text1}
                      color={location.pathname === "/" ? "black" : "white"}
                    />
                  </ListItemText>
                </ListItem>
              ))}
            </List>
            {index === 0 ? (
              <img
                src={location.pathname === "/" ? logo : logo1}
                width={120}
                height={"auto"}
              />
            ) : (
              ""
            )}
          </Grid>
        ))}
        <Grid
          item
          lg={12}
          sm={12}
          xs={12}
          md={12}
          sx={{ margin: "auto", textAlign: "center" }}
        >
          <hr />
          <TypographyText
            Typography="Copyright 2018-2024 © Vedaham Business Solutions Pvt Ltd."
            textAlign="centre"
            color={location.pathname === "/" ? "black" : "white"}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default Foter;
